import { render, staticRenderFns } from "./ProgressAndTargetReset.vue?vue&type=template&id=587a25ba&scoped=true&"
import script from "./ProgressAndTargetReset.vue?vue&type=script&lang=js&"
export * from "./ProgressAndTargetReset.vue?vue&type=script&lang=js&"
import style0 from "./ProgressAndTargetReset.vue?vue&type=style&index=0&id=587a25ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a25ba",
  null
  
)

export default component.exports